module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "project-title"
  }, [_vm._v("SCRAPFLOWER PILLOWS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("These pretty pillows are wonderful companions to the Scrapflower Quilts. They feature four flower blocks in different colourways, framed by a simple border. The pillows use some of the same fabrics as the quilt and in smaller quantities. Refer to the fabric swatches in "), _c('a', {
    attrs: {
      "href": "#/Chapter2#figA"
    }
  }, [_c('b', [_vm._v("Fig A")])]), _vm._v(" of the quilt instructions. The blue pillow is described. The yellow pillow is made in the same way as the blue, but uses Solid pale yellow in place of Solid cornflower blue.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-F1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fabric 3: 12in (30.5cm) square – Bonnie red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 5: 10in (25.4cm) square – Shirly red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 8: 10in (25.4cm) square – Shirly dove white")]), _vm._v(" "), _c('li', [_vm._v("Fabric 10: 10in (25.4cm) square – Nancy yellow")]), _vm._v(" "), _c('li', [_vm._v("Fabric 11: 10in (25.4cm) square – Shirly teal")]), _vm._v(" "), _c('li', [_vm._v("Fabric 12: 10in (25.4cm) square – Nancy teal")]), _vm._v(" "), _c('li', [_vm._v("Fabric 21: 5in (12.7cm) square – Pearls pink")]), _vm._v(" "), _c('li', [_vm._v("Fabric 22: 5in (12.7cm) square – Pearls yellow")]), _vm._v(" "), _c('li', [_vm._v("Fabric 25: 10in (25.4cm) square – Pearls green")]), _vm._v(" "), _c('li', [_vm._v("Fabric 26: 10in (25.4cm) square – Solid sky teal")]), _vm._v(" "), _c('li', [_vm._v("Fabric 27: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (50cm) – Solid cornflower blue (or Solid pale yellow)")]), _vm._v(" "), _c('li', [_vm._v("Wadding (batting) 24in (61cm) square")]), _vm._v(" "), _c('li', [_vm._v("Lining fabric 24in (61cm) square (optional)")]), _vm._v(" "), _c('li', [_vm._v("Fabric for back of pillow, two pieces 15in x 22"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (38cm x 57.2cm)")]), _vm._v(" "), _c('li', [_vm._v("Binding fabric "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("yd (25cm) – Pearls yellow")]), _vm._v(" "), _c('li', [_vm._v("Erasable marker")]), _vm._v(" "), _c('li', [_vm._v("Pillow pad to fit cover")])]), _vm._v(" "), _c('p', {
    staticClass: "finish-head"
  }, [_c('b', [_vm._v("Finished Size")]), _vm._v(" 22in x 22in (56cm x 56cm)")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("PREPARATION AND CUTTING OUT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("1")]), _vm._v(" From Fabric 27 cornflower blue (or pale yellow) cut the following for the blocks.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Piece "), _c('b', [_vm._v("a")]), _vm._v(" – 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 4"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.8cm x 11.4cm). Cut 16 in total.")]), _vm._v(" "), _c('li', [_vm._v("Piece "), _c('b', [_vm._v("c")]), _vm._v(" – 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 3"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm x 9cm). Cut 16 in total.")]), _vm._v(" "), _c('li', [_vm._v("Piece "), _c('b', [_vm._v("d")]), _vm._v(" – 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.8cm) square. Cut 32 in total.")]), _vm._v(" "), _c('li', [_vm._v("Piece "), _c('b', [_vm._v("e")]), _vm._v(" – 3"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (9cm x 3.8cm). Cut 16 in total.")]), _vm._v(" "), _c('li', [_vm._v("Piece "), _c('b', [_vm._v("g")]), _vm._v(" – 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.8cm) square. Cut 32 in total.")])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("2")]), _vm._v(" From Fabric 27 cornflower blue (or pale yellow) for the outer border cut two strips 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 20"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.8cm x 52cm) and two strips 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 22"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.8cm x 57.2cm).")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("3")]), _vm._v(" For the print fabrics, follow "), _c('a', {
    attrs: {
      "href": "#/Chapter2#figA"
    }
  }, [_c('b', [_vm._v("Fig A")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Chapter2#figB"
    }
  }, [_c('b', [_vm._v("Fig B")])]), _vm._v(" here for block layout and colourways.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cut "), _c('b', [_vm._v("b")]), _vm._v(" pieces 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 4"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm x 11.4cm).")]), _vm._v(" "), _c('li', [_vm._v("Cut "), _c('b', [_vm._v("f")]), _vm._v(" pieces 3"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (9cm) square.")]), _vm._v(" "), _c('li', [_vm._v("Cut "), _c('b', [_vm._v("h")]), _vm._v(" pieces 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm) square.")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig A")]), _vm._v(" Layout and cutting for one quadrant and the centre of a block")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figA"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-F2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig B")]), _vm._v(" Flower block colourways"), _c('br'), _vm._v("Numbers indicate fabrics used. Make 1 of each block")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figB"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-F3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("4")]), _vm._v(" From the binding fabric cut three 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm) x width of fabric strips. Sew together into one long length, press seams open and prepare as a double-fold binding.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MAKING THE PATCHWORK")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("5")]), _vm._v(" To make the blocks follow the "), _c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("Scrapflower Quilt instructions (Steps 6 to 12)")]), _vm._v(". Make one of each block.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("6")]), _vm._v(" Once made, sew the blocks together into pairs and press. Now sew the pairs together, as shown in "), _c('a', {
    attrs: {
      "href": "#/Chapter2#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v(" here. Sew the short border strips to the top and bottom of the patchwork and press. Sew the longer strips to the sides and press.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig C")]), _vm._v(" Assembling the pillow")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figC"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-F4.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("QUILTING AND MAKING UP")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("7")]), _vm._v(" Make a quilt sandwich of the patchwork, wadding (batting) and lining fabric (if using). Quilt as desired. Trim excess wadding and lining to match the patchwork size.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("8")]), _vm._v(" Make up and bind the pillow cover following the method given in "), _c('span', {
    attrs: {
      "href": "#/Techniques#CT-F2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Techniques: Bound-Edge Pillow Cover")]), _vm._v(". Press the cover and insert a pillow pad to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-F5.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b868a7d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter2.vue
// module id = 72
// module chunks = 0